import React, { useEffect } from 'react';

export default function ParticlesComponent() {
  useEffect(() => {
    const isMobile = window.innerWidth < 768; 
    
    if (window.particlesJS) {
      window.particlesJS('particles-js', {
        // ... (باقي إعدادات الجسيمات كما هي)
        particles: {
          number: {
            value: isMobile ? 80 : 120, 
            density: { enable: true, value_area: 800 },
          },
          color: { value: '#22ff9b' },
          shape: { type: 'circle' },
          opacity: {
            value: 0.35,
            random: true,
            anim: { enable: true, speed: 1, opacity_min: 0.1, sync: false },
          },
          size: {
            value: isMobile ? 2.5 : 3, 
            random: true,
            anim: { enable: true, speed: 1, size_min: 0.5, sync: false },
          },
          line_linked: {
            enable: true,
            distance: isMobile ? 100 : 130,
            color: '#22ff9b',
            opacity: isMobile ? 0.15 : 0.2, 
            width: 1,
          },
          move: {
            enable: true,
            speed: 1.2,
            direction: 'none',
            random: true,
            straight: false,
            out_mode: 'out',
            attract: { enable: true, rotateX: 600, rotateY: 1200 },
          },
        },
        
        // **إعدادات التفاعل التي تسمح بالماوس (هي بالفعل صحيحة)**
        interactivity: {
          detect_on: 'canvas',
          events: {
            // التحويم (Hover) هو ما يجعلها تتفاعل مع حركة الماوس
            onhover: { enable: isMobile ? false : true, mode: ['grab', 'repulse'] }, 
            onclick: { enable: true, mode: 'push' },
            resize: true,
          },
          modes: {
            // تحديد مسافة وتأثير وضعيتي الجذب والتنافر
            grab: { distance: isMobile ? 100 : 180, line_linked: { opacity: isMobile ? 0.3 : 0.45 } },
            repulse: { distance: isMobile ? 80 : 150, duration: 0.4 },
            push: { particles_nb: 5 },
            bubble: { distance: 250, size: 6, duration: 2, opacity: 0.3, speed: 3 },
          },
        },
        retina_detect: true,
      });
    }
  }, []);

  return (
    <div
      id="particles-js"
      // **قم بإزالة pointer-events-none للسماح بالتفاعل**
      className="fixed inset-0 w-full h-full z-0" 
    />
  );
}